// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-edit-checkpoint-remove-button {
  display: inline-block;
  margin: 45px 6px 0;
}
.fi-checklist-edit-checkpoint-remove-button .mat-mdc-button .mat-icon {
  color: var(--fi-color-dark);
  height: 100%;
  width: 100%;
  font-size: 20px;
  line-height: 36px;
}
.fi-checklist-edit-checkpoint-remove-button .mat-mdc-button[disabled] .mat-icon {
  color: var(--fi-color-extra-light);
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/edit/checkpoint-remove-button/checkpoint-remove-button.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;AACJ;AAEQ;EACI,2BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAAZ;AAIY;EACI,kCAAA;AAFhB","sourcesContent":[".fi-checklist-edit-checkpoint-remove-button {\r\n    display: inline-block;\r\n    margin: 45px 6px 0;\r\n\r\n    .mat-mdc-button {\r\n        .mat-icon {\r\n            color: var(--fi-color-dark);\r\n            height: 100%;\r\n            width: 100%;\r\n            font-size: 20px;\r\n            line-height: 36px;\r\n        }\r\n\r\n        &[disabled] {\r\n            .mat-icon {\r\n                color: var(--fi-color-extra-light);\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
